import FaqSection from '@/components/FaqSection';
import Footer from '@/components/Footer';

export default function FaqPage() {
  return (
    <div className="pt-20">
      <FaqSection />
      <Footer />
    </div>
  );
}
